export default __webpack_public_path__ + "static/media/acter2.7823d0a4.png";